import React, { useCallback } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  FormControlLabel,
  FormGroup,
  List,
  ListItem,
} from "@mui/material";
import assest from "../../json/assest";
import styles from "../../styles/components/displayRelease.module.scss";
import { useAppSelector } from "../../hooks/useAppSelector";
import {
  setFrom,
  setTo,
  setReleaseStatus,
  setReleaseCompany,
} from "../../redux-toolkit/slices/released.video.slice";
import { useDispatch } from "react-redux";
import { setCompanies } from "../../redux-toolkit/slices/app.state.slice";

const ReleasedVideosFilterModal = (props) => {
  const { hideBottom, onClose, modalFields, ...rest } = props;
  //   console.warn("...rest", rest);
  // console.warn("handleClearFilterModal", props);

  const { from, to, release_status, release_company } = useAppSelector(
    (s) => s.releasedVideoSlice
  );

  const { companies } = useAppSelector((s) => s.appStateSlice);
  // console.warn("companies", companies);
  const handleClose = useCallback(
    (e, reason) => {
      onClose?.(e, reason || "backdropClick");
    },
    [onClose]
  );

  const dispatch = useDispatch();

  // console.warn("release_company", release_company);

  const handleChange = (e) => {
    // console.warn("e.target.value", e.target.value);

    let comeVal = e.target.value;

    if (release_company.includes(comeVal)) {
      dispatch(setReleaseCompany(release_company.filter((c) => c != comeVal)));
    } else {
      dispatch(setReleaseCompany([...release_company, comeVal]));
    }
  };

  return (
    <Dialog
      className={`${styles.dialogmodalfilter} filterModal`}
      onClose={handleClose}
      //   open={open}
      {...rest}
      sx={{
        "& .MuiDialog-container": {
          alignItems: "flex-start",
        },
        "& .MuiPaper-elevation": {
          marginTop: "62px",
        },
      }}
    >
      <Box className="filterModalWrapper filterModalWrapperDisplay">
        <Box className="filterModalHeader here">
          <h4>Display released videos for:</h4>
          <Button onClick={props?.handleClearFilterModal}>
            <img src={assest.resetIcon} width={9} height={9} alt="" />
            <p>Clear</p>
          </Button>
        </Box>

        <Box className="filterModalBody">
          <Box className={styles.displayReleaseWrapper}>
            <Box className={styles.messageModalBody}>
              <Box className={styles.videoReleaseBox}>
                <Button
                  className={`${styles.videoReleseBosItem} ${
                    release_status == 1 && styles.videoReleseBosItemActive
                  }`}
                  onClick={() => dispatch(setReleaseStatus(1))}
                >
                  <img
                    src={assest.copyRighticon}
                    width={43}
                    height={43}
                    alt=""
                  />
                  <h4>Copyright Dispute</h4>
                </Button>

                <Button
                  onClick={() => dispatch(setReleaseStatus(2))}
                  className={`${styles.videoReleseBosItem} ${
                    release_status == 2 && styles.videoReleseBosItemActive
                  }`}
                >
                  <img
                    src={assest.somethingElseIcon}
                    width={43}
                    height={43}
                    alt=""
                  />
                  <h4>Something Else</h4>
                </Button>
              </Box>
            </Box>

            <Box className={styles.releaseCheckBox}>
              <h4>
                Released to:{" "}
                <img
                  onClick={() => dispatch(setReleaseCompany([]))}
                  src={assest.resetIconBlue}
                  width={9}
                  height={9}
                  alt=""
                />
              </h4>

              <Box className={styles.releaseCheckList}>
                <FormGroup>
                  {companies?.map((c, i) => (
                    <FormControlLabel
                      checked={release_company.includes(c.company)}
                      onChange={handleChange}
                      key={i}
                      required
                      control={<Checkbox />}
                      label={c.company}
                      value={c.company}
                    />
                  ))}
                </FormGroup>
              </Box>
              {/* <List>
                <ListItem>
                  <FormGroup>
                    <FormControlLabel
                      required
                      control={<Checkbox />}
                      label="ViralHog"
                    />
                  </FormGroup>
                </ListItem>
                <ListItem>
                  <FormGroup>
                    <FormControlLabel
                      required
                      control={<Checkbox />}
                      label="Jukin Media"
                    />
                  </FormGroup>
                </ListItem>
                <ListItem>
                  <FormGroup>
                    <FormControlLabel
                      required
                      control={<Checkbox />}
                      label="CollabDRM"
                    />
                  </FormGroup>
                </ListItem>
                <ListItem>
                  <FormGroup>
                    <FormControlLabel
                      required
                      control={<Checkbox />}
                      label="Newsflare"
                    />
                  </FormGroup>
                </ListItem>
                <ListItem>
                  <FormGroup>
                    <FormControlLabel
                      required
                      control={<Checkbox />}
                      label="Storyful"
                    />
                  </FormGroup>
                </ListItem>
              </List> */}
            </Box>
          </Box>
        </Box>

        <Box className="filterModalFooter">
          <Box className="buttonGroup">
            <Button onClick={handleClose}>Cancel</Button>
            <Button
              onClick={props?.filterRefetch}
              className={`${styles.filter_now_btns} activeButton`}
            >
              Filter <span> now</span>
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ReleasedVideosFilterModal;
